export interface BaseEntity { readonly id?: string; }

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
